import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import theme from 'theme';

import DefaultButton from 'components/buttons/DefaultButton';
import { Button } from 'components/detailsModal/styledElements/detailsModalStyledElements';
import {
  ButtonContainer,
  Header,
  InformationContainer,
  InformationItem,
} from 'components/detailsModal/styledElements/informationStyledElements';
import { ModalContext } from 'contexts/ModalContext';
import { AdminRoutes } from 'modules/router/models';

import ActionAgreement from '../ActionAgreement';
import { StatusBE } from '../models';

type OffersInAccount = {
  activeOffersCount?: number;
  suspendedOffersCount?: number;
  expiredOffersCount?: number;
};

type CorporateAccountInformationProps = {
  color: string;
  isChecked: boolean;
  offersInAccount: OffersInAccount;
  accountStatus: StatusBE;
  closeModal: () => void;
  activateAccount: () => void;
  toggleStatus: () => void;
};

const CorporateAccountInformation = ({
  color,
  isChecked,
  closeModal,
  toggleStatus,
  accountStatus,
  activateAccount,
  offersInAccount: {
    activeOffersCount,
    suspendedOffersCount,
    expiredOffersCount,
  },
}: CorporateAccountInformationProps) => {
  const { setModalOpen } = useContext(ModalContext);
  const isAnyAccountOfferExist =
    !!activeOffersCount || !!suspendedOffersCount || !!expiredOffersCount;

  return (
    <>
      {accountStatus === StatusBE.Suspend ? (
        <div>
          <ActionAgreement
            note="All offers will be activated"
            isChecked={isChecked}
            actionTypeText="YES ACTIVATE THIS ACCOUNT"
            toggleStatus={toggleStatus}
          />
        </div>
      ) : (
        <>
          {isAnyAccountOfferExist && (
            <InformationContainer>
              <Header>Offers</Header>
              <br />
              {!!activeOffersCount && (
                <InformationItem>
                  <span>Active:</span> {activeOffersCount}
                </InformationItem>
              )}
              {!!suspendedOffersCount && (
                <InformationItem>
                  <span>Suspended:</span> {suspendedOffersCount}
                </InformationItem>
              )}
              {!!expiredOffersCount && (
                <InformationItem>
                  <span>Expired:</span> {expiredOffersCount}
                </InformationItem>
              )}
            </InformationContainer>
          )}
        </>
      )}
      <ButtonContainer $color={color}>
        {accountStatus === StatusBE.Suspend ? (
          <>
            <DefaultButton
              text="activate"
              textColor={color}
              isActive={isChecked}
              withShadow
              buttonColor={theme.colors.white}
              isUppercase
              buttonSize="md"
              borderSize="md"
              clickHandler={activateAccount}
            />
            <Button onClick={closeModal}>cancel</Button>
          </>
        ) : (
          <>
            <StyledNavLink to={`../${AdminRoutes.Offers}`}>
              <DefaultButton
                text="create offer"
                textColor={theme.colors.funtainBlue}
                isActive
                withShadow
                buttonColor={theme.colors.white}
                isUppercase
                buttonSize="md"
                borderSize="md"
                clickHandler={() => {
                  setModalOpen(true);
                }}
              />
            </StyledNavLink>

            <NavLink to={`../${AdminRoutes.Offers}`}>
              <Button>manage offers</Button>
            </NavLink>
          </>
        )}
      </ButtonContainer>
    </>
  );
};

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
`;

export default CorporateAccountInformation;
